import { Injectable } from '@angular/core';
import { HttpClient,HttpParams} from '@angular/common/http';
import { LoginComponent } from './admin/login.component';
import { HttpHeaders } from '@angular/common/http';
import {   LocalStorageService, LocalStorage } from 'angular-web-storage';



@Injectable({
  providedIn: 'root'
})
export class DataserviceService {
  adminLogin(data){
    
    console.log(data);
    return this.http.post<any>(this.baseUrl + '/admin/signin',{email:data.email,
      password:data.password,
      "device_type": 1,
      "device_id": "32_char_device_const",
      "device_token": "fcm_id2"
     });
    

  }




  // getbanklist api start here
  getbankList(page, keyword){
    const httpOptions = {
     
      params: new HttpParams()
        .set('bank_name', keyword)
        .set('page', page)
    };

    return this.http.get<any>(this.baseUrl + '/bank/list',httpOptions)
  }




// get updates api start here
getUpdateList(page,keyword,type){
  const httpOptions = {
     
    params: new HttpParams()
      .set('title', keyword)
      .set('page', page)
      .set('type',type)
  };
  return this.http.get<any>(this.baseUrl + '/update/list',httpOptions)
}




// get update for slider api start here


// get updates api start here
getUpdate(){

  return this.http.get<any>(this.baseUrl + '/updates')
}



// remove bank api start here
removeBank(val){

  var userToken = localStorage.getItem("userToken");
  var data = {
    body: {   
      'id': val
      
    },
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': userToken,
    })
  }




  return this.http.delete<any>(this.baseUrl + '/admin/bank/remove',data);
}


// remove updates api start here


removeUpdate(val){
  console.log(val);
  

  var userToken = localStorage.getItem("userToken");
  var data = {
    body: {   
      'id': val
      
    },
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': userToken,
    })
  }




  return this.http.delete<any>(this.baseUrl + '/admin/update/remove',data);
}




// change password api start here
changePassword1(data1){
  var userToken = localStorage.getItem("userToken");
  var data = {
    old_password:data1.old_password,
    new_password:data1.new_password
  }
  const httpOptions ={
    headers:new HttpHeaders({
      'content-type':'application/json',
      'Authorization':userToken
    })
  }

  // var data = new HttpParams()
  //     .set('type', val);
    // const headers = new HttpHeaders().set('Authorization', userToken);

  return this.http.post<any>(this.baseUrl + '/admin/password/change',data,httpOptions)
}




// logout api start here

logout1(){
  var userToken = localStorage.getItem("userToken");
  var data = new HttpParams()
  .set('type', 'test1');
  const headers = new HttpHeaders().set('Authorization', userToken);

console.log(headers);


  return this.http.post<any>(this.baseUrl + '/admin/logout', data, { headers: headers })
}





// bank detail api start here
bankDetail(val){
  const httpOptions = {
  
    params: new HttpParams()
      .set('bank_id', val)
  };
  console.log(httpOptions.params.toString());
  
  return this.http.get<any>(this.baseUrl + '/bank/card-info',httpOptions)
}





// update detail api start here
updateDetail(val){
  const httpOptions = {
  
    params: new HttpParams()
      .set('id', val)
  };
  console.log(httpOptions.params.toString());
  
  return this.http.get<any>(this.baseUrl + '/update/detail',httpOptions)
}





// dashboard api start here

dashboardData(){
  var userToken = localStorage.getItem("userToken");
  const httpOptions ={
    headers:new HttpHeaders({
      'Authorization':userToken
    })
  };



  return this.http.get<any>(this.baseUrl + '/admin/dashboard',httpOptions)
}

// add bank api start here
addBank1(val){
  console.log(val);
  
  var userToken = localStorage.getItem("userToken");
  if(val.id){
    console.log("1");
    
    var data = {
   
      'id':val.id, 
      'number':val.number,
      'name': val.name,
      'personal_card': val.personal_card,
      'personal_card_no': val.personal_card_no,
      'business_card': val.business_card,
       'business_card_no': val.business_card_no,
       'int_personal_card': val.int_personal_card,
       'int_personal_card_no': val.int_personal_card_no,
       'int_business_card': val.int_business_card,
       'int_business_card_no': val.int_business_card_no
  
    
  }
  }
  else{
    console.log("2");
  var data = {
   
      'id':null, 
      'name': val.name,
      'number':val.number,
      'personal_card': val.personalcard,
      'personal_card_no': val.personalcardnumber,
      'business_card': val.busiicard,
       'business_card_no': val.busiicardnumber,
       'int_personal_card': val.intpercard,
       'int_personal_card_no': val.intpercardnumber,
       'int_business_card': val.intbusiicard,
       'int_business_card_no': val.intbusiicardnumber
  
    
  }
}
  const headers = new HttpHeaders().set('Authorization', userToken);


  return this.http.post<any>(this.baseUrl + '/admin/bank/save',data,{headers:headers});



}



// forgot password api start here
forgotPass1(val){


  var data = {
  
      'email':val 
      
      
    
  }

  return this.http.post<any>(this.baseUrl + '/admin/password/forgot',data);

}





// add update api start here
addUpdate1(val){
  console.log(val);
  
  var userToken = localStorage.getItem("userToken");
  if(val.id){
    console.log("1");
    var data = {
   
      'type':val.type, 
      'title': val.title,
      'description': val.description,
      'personal_card_no': val.personalcardnumber,
      'posted_by': val.posted_by,
      'web_link': val.web_link,
      'image':val.image,
      'id':val.id,
      'posted_on':val.posted_on1
           
  }
  }
  else{
    console.log("2");
  var data = {
   
      'type':val.type, 
      'title': val.title,
      'description': val.description,
      'personal_card_no': val.personalcardnumber,
      'posted_by': val.posted_by,
      'web_link': val.weblink,
      'image':val.image,
      'id':null,
      'posted_on':val.date1

           
  }
}
  const headers = new HttpHeaders().set('Authorization', userToken);


  return this.http.post<any>(this.baseUrl + '/admin/update/save',data,{headers:headers});



}




// reset password api start here
resetPass1(val,val1){
  var data = {
   
    'token':val1, 
    'password': val.confirmPass
         
}


return this.http.post<any>(this.baseUrl + '/admin/password/reset',data);

}




// upload image with filename api start here
showImageFunction(val){
  const httpOptions = {
  
    params: new HttpParams()
      .set('filename', val)
  };
  return this.http.get<any>(this.baseUrl + '/upload',httpOptions);

}


  constructor(private http: HttpClient) { }
  baseUrl="http://18.224.22.40:3000/api"
}
